import React, { useEffect, useState } from 'react';

const SplashScreen: React.FC = () => {
    const [customLoadingUrl, setCustomLoadingUrl] = useState<string | null>(null);

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        try {
            const cached = localStorage.getItem('xc_site_assets');
            if (cached) {
                const assets = JSON.parse(cached);
                if (assets.loadingScreenUrl) {
                    setCustomLoadingUrl(assets.loadingScreenUrl);
                    setIsVisible(true);
                }
            }
        } catch (e) { }
    }, []);

    if (!isVisible || !customLoadingUrl) return null;

    return (
        <div
            className="fixed inset-0 z-[9999] bg-slate-950 flex items-center justify-center overflow-hidden animate-fadeOut delay-2000"
            onAnimationEnd={() => setIsVisible(false)}
        >
            {/* Image removed as per user request for "clean/empty" screen
            <img
                src={customLoadingUrl}
                alt="Loading..."
                className="absolute inset-0 w-full h-full object-cover opacity-80 animate-pulse-slow"
            />
            */}
            <div className="relative z-10 flex flex-col items-center">
                <div className="w-12 h-12 border-4 border-white/20 border-t-sky-500 rounded-full animate-spin shadow-2xl"></div>
            </div>
        </div>
    );
};

export default SplashScreen;
